import { render, staticRenderFns } from "./charactersList.vue?vue&type=template&id=14b1bcfb&scoped=true&"
import script from "./charactersList.vue?vue&type=script&lang=js&"
export * from "./charactersList.vue?vue&type=script&lang=js&"
import style0 from "./charactersList.vue?vue&type=style&index=0&id=14b1bcfb&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14b1bcfb",
  null
  
)

export default component.exports